module.exports = __webpack_public_path__ + "img/header-diamondJewelryPlatinum@2x.f1b0adc.jpg";